import { AnalysisAutomationItem } from 'modules/analyse/types/AutomationTasks';

export const findParentAutomationTaskId = (
  automationTaskId: string,
  automationTasks: AnalysisAutomationItem[]
) => {
  const automationTask = automationTasks.find(
    (automationTask) => automationTask.id === automationTaskId
  );

  return automationTask?.parentAutomationTaskId;
};
